/**
 * Main
 */

(function ($) {
    "use strict";

    // Show/hide JavaScript related elements.

    $('.hide-if-js').hide();
    $('.hide-if-no-js').show();

})(jQuery);

(function ($) {
    $('.btn-social').click(function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        window.open(url, 'share-dialog', "width=626,height=436");
    });

})(jQuery);

(function ($) {
    $(window).ready(function () {
        // The lines below are executed on page load
        $('.gfield input, .gfield textarea').each(function () {
            checkForInput(this);
        });

        // The lines below (inside) are executed on change & keyup
        $('.gfield input, .gfield textarea').on('change keyup', function () {
            checkForInput(this);
        });

        $('body').on('click', function (e) {
            var target = e.target;

            $('.gfield').removeClass('input-focused');

            if ($(target).parents('.gform_wrapper').length) {
                $(target).parents('.gfield').addClass('input-focused');
                var currentTarget = $(target);
            }
        });

        function checkForInput(element) {
            if ($(element).val().length > 0) {
                $(element).parents('.gfield').addClass('input-completed');
            } else {
                $(element).parents('.gfield').removeClass('input-completed');
            }
        }
    });


})(jQuery);

(function ($) {
    jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
        $('.form-wrapper').removeClass('transparent');
    });
})(jQuery);

(function ($) {
    var width = $(window).width();

    $(document).ready(function () {
        $('.navbar-toggler').on('click', function () {
            $(this).removeClass('collapsed');
            $('body').addClass('mobile-header-open');
            $('#masthead').append('<div class="header-backdrop faded" />');

            setTimeout(function () {
                $('#masthead').find('.header-backdrop').removeClass('faded');
            }, 150);
        });

        $('#masthead').on('click', '.header-backdrop', closeHeader);
        $('#masthead').on('click', '.close', closeHeader);

    });

    $(window).on('resize', function () {
        width = $(window).width();

        if (width > 768) {
            closeHeader();
        }
    });

    function closeHeader() {
        $('.navbar-toggler').addClass('collapsed');
        $('body').removeClass('mobile-header-open');
        $('body').find('.header-backdrop').addClass('faded');

        setTimeout(function () {
            $('body').find('.header-backdrop').remove();
        }, 400);
    }

})(jQuery);

// Sub menu open desktop/mobile

(function ($) {
    $(document).ready(function () {
        var wWidth = $(window).width();
        var dropdownMenus = $('.menu-item.dropdown');

        if (wWidth >= 768) {
            openDesktop(dropdownMenus);
        }

        $(window).resize(function () {
            wWidth = $(window).width();

            if (wWidth >= 768) {
                openDesktop(dropdownMenus);
            }
        });
    });

    function openDesktop(dropdownMenus) {
        dropdownMenus.each(function () {
            var dropdownMenu = $(this);

            dropdownMenu.on('mouseover', function () {
                $(this).addClass('show');
                $(this).find('.dropdown-menu').addClass('show');
            });

            dropdownMenu.on('mouseout', function () {
                $(this).removeClass('show');
                $(this).find('.dropdown-menu').removeClass('show');
            });
        });
    }

})(jQuery);



/**
 * Reload Form
 */

// let's make call to the global gwrf variable visible after enabling Gravity Forms
window.gwrf;

(function ($) {
    $(window).ready(function () {

        gwrf = function (args) {
            // prototype arguments, created when we instantiate it
            this.formId = args.formId;
            this.spinnerUrl = args.spinnerUrl;
            this.refreshTime = args.refreshTime;
            this.refreshTimeout = null;

            // form wrapper class followed by the form id
            this.formWrapper = $('#gform_wrapper_' + this.formId);
            this.staticElem = this.formWrapper.parent();

            // we want to make sure that we'll have the cloned form html
            this.formHtml = $('<div />').append(this.formWrapper.clone()).html();

            this.spinnerInitialized = false;

            this.init = function () {

                var gwrf = this;

                // this is Gravity Forms .js hook which we bind a function call to
                // once the AJAX confirmation was loaded we'll trigger the function
                $(document).bind('gform_confirmation_loaded', function (event, formId) {

                    // let's make sure we'll reload the right form
                    if (formId != gwrf.formId || gwrf.refreshTime <= 0)
                        return;

                    // let's reload the form after some time
                    gwrf.refreshTimeout = setTimeout(function () {
                        gwrf.reloadForm();
                    }, gwrf.refreshTime * 1000);

                });

                // let's make sure that the form will be closed only after the .closed-lightbox element was
                // clicked on. This might be a button in the top right corner of our popup
                $('.btn-close').on('click', function (event) {
                    event.preventDefault();

                    setTimeout(function () {
                        gwrf.reloadForm();
                    }, 500);

                });

            };

            // heart of our functionality
            this.reloadForm = function () {

                // let's check if the confirmation message has already been created
                if (this.staticElem.find('.gform_confirmation_message_' + this.formId).length) {
                    if (this.refreshTimeout)
                        clearTimeout(this.refreshTimeout);

                    // let's look for the confirmation element and get the HTML of the parent form
                    this.staticElem.find('.gform_confirmation_message_' + this.formId)
                        .wrap('<div />').parent().html(this.formHtml);
                    // let's get rid of the HTML of the FORM
                    this.staticElem.find('#gform_wrapper_' + this.formId).unwrap();

                    // let's rerender the form
                    $(document).trigger('gform_post_render', [this.formId, 0]);
                    // if we had datepicker let's reinstantiate it
                    if (window['gformInitDatepicker'])
                        gformInitDatepicker();
                }
            };

            // utility used to display the "spinner" loading image
            this.initSpinner = function () {

                var gwrf = this;

                this.staticElem.on('submit', '#gform_' + this.formId, function () {
                    $('#gform_submit_button_' + gwrf.formId).attr('disabled', true).after('<' + 'img id=\"gform_ajax_spinner_' + gwrf.formId + '\"  class=\"gform_ajax_spinner\" src=\"' + gwrf.spinnerUrl + '\" />');
                    gwrf.formWrapper.find('.gform_previous_button').attr('disabled', true);
                    gwrf.formWrapper.find('.gform_next_button').attr('disabled', true).after('<' + 'img id=\"gform_ajax_spinner_' + gwrf.formId + '\"  class=\"gform_ajax_spinner\" src=\"' + gwrf.spinnerUrl + '\" alt=\"\" />');
                });

            };

            this.init();

        };
    });

})(jQuery);